<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.leads') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :subItemFields="subItemFields" :list-url="listUrl" ref="lead-table"
                    v-on:refresh="resetFilter">
                    <b-button variant="primary" @click="$router.go(-1)">
                        <b-icon icon="arrow-left" class="icon-style"></b-icon>
                    </b-button>
                    <b-button variant="primary" @click="handleUserAction">
                        <b-icon icon="person-plus" class="icon-style"></b-icon>
                    </b-button>
                    <b-button variant="primary" @click="$router.push({ name: 'savedMondaycrmLeads' })">
                        <b-icon icon="bookmark" class="ms-2"></b-icon>
                    </b-button>
                    <template #cell(action)="{ item }">
                        <input type="checkbox" :value="item.owner" v-model="selectedUsers" class="mr-2" />
                    </template>
                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'action', label: self.$t('title.action') },
    { key:'monday_id',label: self.$t('title.monday_id'), sortable: false },
    { key: 'expand', label: self.$t('title.expand'), sortable: true },
    { key: 'integration.name', label: self.$t('title.integration'), sortable: true },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'status', label: self.$t('title.status'), sortable: true },
    { key: 'company', label: self.$t('title.company'), sortable: true },
    { key: 'title', label: self.$t('title.title'), sortable: true },
    { key: 'email', label: self.$t('title.email'), sortable: true },
    { key: 'phone', label: self.$t('title.phone'), sortable: true },
    { key: 'last_interation', label: self.$t('title.last_interation'), sortable: true },
    { key: 'active_sequence', label: self.$t('title.active_sequence'), sortable: true },
    { key: 'comments', label: self.$t('title.comments'), sortable: true },
    { key: 'location', label: self.$t('title.location'), sortable: true },
    { key: 'owner', label: self.$t('title.owner'), sortable: true },
    { key: 'created_at', label: self.$t('title.created_at'), sortable: true }

];

export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
            columns: [],
            subItemFields: [
                { key: 'name', label: this.$t('title.name') },
                { key: 'people', label: this.$t('title.people') },
                { key: 'status', label: this.$t('title.status') },
                { key: 'date', label: this.$t('title.date') }
            ]
        };
    },
    created() {
        this.columns = COLUMN_STATE(this);
        this.fetchLeads();
    },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['lead-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        async handleUserAction() {
            this.isLoading = true; // optional loading state if needed
            const payload = {
                owners: this.selectedUsers
            };

            try {
                const response = await request({
                    method: 'post',
                    url: '/admin/save/monday/leads',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json' // Content type for JSON data
                    }
                });

                if (response.status === true) {
                    this.$bvToast.toast('User stored successfully!', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    this.$bvToast.toast('User storage failed.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error("Error storing user IDs:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
                // You might also want to show an error toast
                this.$bvToast.toast(this.errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['lead-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
        async fetchLeads() {
            try {
                const response = await request({
                    method: 'get',
                    url: this.listUrl,
                });
                const leadsData = response.data;

                let customFieldKeys = new Set(); // Store unique custom field names
                let subItemCustomFieldKeys = new Set();

                // Transform data to include custom fields
                const transformedLeads = leadsData.map(lead => {
                    // let customFieldsObj = {};

                    if (lead.sub_items) {
                        lead.sub_items.forEach(subItem => {
                            subItem.custom_fields.forEach(subField => {
                                const formattedSubKey = subField.field_name.toLowerCase().replace(/\s+/g, '_'); // Convert to snake_case
                                // customFieldsObj[formattedKey] = field.field_value || ""; // Default empty if null
                                subItemCustomFieldKeys.add(formattedSubKey); // Collect field names
                            });
                        })
                    }

                    if (lead.custom_fields) {
                        lead.custom_fields.forEach(field => {
                            const formattedKey = field.field_name.toLowerCase().replace(/\s+/g, '_'); // Convert to snake_case
                            // customFieldsObj[formattedKey] = field.field_value || ""; // Default empty if null
                            customFieldKeys.add(formattedKey); // Collect field names
                        });
                    }

                    return { ...lead };
                });

                console.log("dsds", customFieldKeys);
                // Merge custom fields into columns
                const customFieldColumns = Array.from(customFieldKeys).map(field => ({
                    key: `${field}`,
                    label: field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()), // Convert back to readable format
                    sortable: true
                }));

                this.columns = [...COLUMN_STATE(this), ...customFieldColumns]; // Merge with base columns
                console.log(this.columns);

                const subItemCustomFieldColumns = Array.from(subItemCustomFieldKeys).map(field => ({
                    key: `${field}`,
                    label: field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()), // Convert back to readable format
                    sortable: true
                }));

                this.subItemFields = [...this.subItemFields, ...subItemCustomFieldColumns];

            } catch (error) {
                console.error("Error fetching leads:", error);
            }
        }
    },
    computed: {
        listUrl() {
            return `admin/monday/leads/${this.$route.params.id || ''}`;
        }
    }
};
</script>
